<template>
	<app-table
		class="is-not-selectable"
		name="action-list"
		:columns="columns"
		:current-page="currentPage"
		:rows="rows"
		:last-page="lastPage"
	>
		<template slot="rows" slot-scope="props">
			<td
				class="is-not-selectable"
			>
				{{ props.row.domain }}
			</td>
			<td>{{ props.row.method }}</td>
			<td>{{ props.row.path }}</td>
			<td>{{ props.row.name }}</td>
			<td>
				<app-tooltip-button
						:color="props.row.flagAuth ? 'green' : 'red'"
						icon="adjust"
						:text="props.row.flagAuth ? 'Autorizado' : 'No Autorizado'"
					/>
			</td>
			<td>
				<app-tooltip-button
					color="green"
					icon="edit"
					text="Editar"
					@click-icon="$emit('edit-service', props.row)"
				/>
				<app-tooltip-button
					color="red"
					icon="delete"
					text="Eliminar"
					@click-icon="$emit('delete-service', props.row)"
				/>
			</td>
		</template>
	</app-table>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{ id: 1, name: 'Dominio', checked: true, visible: true },
			{ id: 2, name: 'Método', checked: true, visible: true },
			{ id: 3, name: 'URI', checked: true, visible: true },
			{ id: 4, name: 'Nombre', checked: true, visible: true },
			{ id: 5, name: 'Auth', checked: true, visible: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
		lastPage: 0,
	};
}

export default {
	name: 'resource-list',
	data,
	components: {
		appTooltipButton,
	},
	props: {
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/resource-service/resource-list.vue